export default __webpack_public_path__ + "static/media/fractals.5ae34bbc.jpg";